import React, { useState } from 'react'
import { Pencil, Copy, Eye, Save, X } from 'lucide-react'
import styles from './CSMTemplates.module.css'
import { SM_TEMPLATES, OCCASION_META } from './smMockData'

const CSMTemplates = () => {
    const [templates, setTemplates] = useState(SM_TEMPLATES)
    const [previewId, setPreviewId] = useState(null)
    const [editId, setEditId] = useState(null)
    const [draftBody, setDraftBody] = useState('')

    const startEdit = (tpl) => {
        setEditId(tpl.identifier)
        setDraftBody(tpl.body)
        setPreviewId(null)
    }

    const saveEdit = (identifier) => {
        setTemplates((prev) => prev.map((t) => (t.identifier === identifier ? { ...t, body: draftBody } : t)))
        setEditId(null)
    }

    const duplicateTemplate = (tpl) => {
        const copy = {
            ...tpl,
            identifier: `${tpl.identifier}_copy_${Date.now()}`,
            name: `${tpl.name} (Copy)`,
            usageCount: 0,
        }
        setTemplates((prev) => {
            const idx = prev.findIndex((t) => t.identifier === tpl.identifier)
            const next = [...prev]
            next.splice(idx + 1, 0, copy)
            return next
        })
    }

    return (
        <div className={styles.page}>
            <div className={styles.pageHeader}>
                <h1 className={styles.pageTitle}>Templates</h1>
                <p className={styles.pageSubtitle}>Instead of writing messages every year, reuse and tweak these.</p>
            </div>

            <div className={styles.list}>
                {templates.map((tpl) => {
                    const meta = OCCASION_META[tpl.occasion]
                    const isPreview = previewId === tpl.identifier
                    const isEdit = editId === tpl.identifier
                    return (
                        <div key={tpl.identifier} className={styles.card}>
                            <div className={styles.cardTop}>
                                <div className={styles.cardTitleRow}>
                                    <span className={styles.cardEmoji}>{meta.emoji}</span>
                                    <span className={styles.cardName}>{tpl.name}</span>
                                </div>
                                <span className={styles.usageBadge}>{tpl.usageCount} sent</span>
                            </div>

                            <div className={styles.cardActions}>
                                <button type="button" className={styles.iconBtn} onClick={() => startEdit(tpl)}>
                                    <Pencil size={13} /> Edit
                                </button>
                                <button type="button" className={styles.iconBtn} onClick={() => duplicateTemplate(tpl)}>
                                    <Copy size={13} /> Duplicate
                                </button>
                                <button
                                    type="button"
                                    className={styles.iconBtn}
                                    onClick={() => { setPreviewId(isPreview ? null : tpl.identifier); setEditId(null) }}
                                >
                                    <Eye size={13} /> Preview
                                </button>
                            </div>

                            {isPreview && (
                                <div className={styles.previewBox}>
                                    {tpl.body.split('\n').map((line, idx) => (
                                        <p key={idx} className={styles.previewLine}>{line || ' '}</p>
                                    ))}
                                </div>
                            )}

                            {isEdit && (
                                <div className={styles.editBox}>
                                    <textarea
                                        className={styles.editTextarea}
                                        value={draftBody}
                                        onChange={(e) => setDraftBody(e.target.value)}
                                        rows={5}
                                    />
                                    <div className={styles.editActions}>
                                        <button type="button" className={styles.saveBtn} onClick={() => saveEdit(tpl.identifier)}>
                                            <Save size={13} /> Save
                                        </button>
                                        <button type="button" className={styles.cancelBtn} onClick={() => setEditId(null)}>
                                            <X size={13} /> Cancel
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default CSMTemplates
